/**
 * (c) 2021-2022, Nous Educational Foundation and contributors
 *
 * SPDX-License-Identifier: MIT
 */
import { Text, TextProps } from "@chakra-ui/layout";
import { Flex } from "@chakra-ui/react";
import V2Tag from "../common/V2Tag";

interface DocumentationHeadingProps extends TextProps {
  name: string;
  isV2Only: boolean;
}

const DocumentationHeading = ({
  name,
  isV2Only,
  ...props
}: DocumentationHeadingProps) => {
  return (
    <Text as="h3" fontSize="lg" fontWeight="semibold" {...props}>
      {/* 扩展中心才有图片 */}
        {
          name === 'loT' && 
          <img src='https://coding.matatalab.com/static/assets/68e366e6cb3f8eae4f3cf134ba69db2a.png' alt="" />
        }
        {
          name === 'Bluetooth_Controller' && 
          <img src='https://coding.matatalab.com/static/assets/cf2a86b5b6bebebfc8e4dcd5e083c8c7.png' alt="" />
        }
        {/* {
          name === 'AI' && 
          <img src='https://coding.matatalab.com/static/assets/4e5be99dbdb1ef786227243ed514eacf.png' alt="" />
        } */}
      {name}
      {isV2Only && (
        <Flex display="inline-flex">
          <V2Tag />
        </Flex>
      )}
    </Text>
  );
};

export default DocumentationHeading;
